import { apiSlice } from "@/redux/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUserDetails: builder.query({
            query: () => `/users/getUserDetails`,
        }),
        login: builder.mutation({
            query: (body) => ({
                url: '/users/login',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['DefectKeys'],
        }),
        logout: builder.mutation({
            query: () => ({
                url: '/users/logout',
                method: 'POST',
            }),
        }),
    }),
});

export const {
    useGetUserDetailsQuery,
    useLoginMutation,
    useLogoutMutation,
} = authApiSlice;
